module.exports = __webpack_public_path__ + "assets/img/lithuania-grey.64e56090.webp";